import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.TAGS_TABLE;

async function createNewTag(data) {
  try {
    return await DBOperationsComb.insertData(tableName, data, false, {
      attribution: false
    });
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateTag(data) {
  try {
    return await DBOperationsComb.updateData(tableName, data, false, {
      attribution: false
    });
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function deleteTag(id) {
  try {
    let data = {
      id,
      is_deleted: true
    };
    let _res = await DBOperationsComb.updateData(tableName, data, false, {
      attribution: false
    });
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function recoverTag(id) {
  try {
    let data = {
      id,
      is_deleted: false
    };
    let _res = await DBOperationsComb.updateData(tableName, data, false, {
      attribution: false
    });
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getTags(config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        fetchDeleted: config.fetchDeleted,
        searchTxt: config.searchTxt,
        sortField: config.sortField,
        sortOrder: config.sortOrder,
        page: config.page,
        rows: config.rows,
        fetchAll: config.fetchAll
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  createNewTag,
  updateTag,
  getTags,
  deleteTag,
  recoverTag
};
